import UIPage from 'UIComponents/page/UIPage';
import { jsxs as _jsxs } from "react/jsx-runtime";
const PersistentFullScreenWrapper = ({
  children
}) => /*#__PURE__*/_jsxs(UIPage, {
  "data-test-id": "full-page-loading-hide-nav",
  children: [" ", children, " "]
});
export default PersistentFullScreenWrapper;